export const PIANO_VIDEOS = [
  { id: "ruby-turner-live", title: "Live with Ruby Turner" },
  { id: "video-2", title: "Live on keys" },
  { id: "summer-of-42", title: "Summer of '42" },
  { id: "shaun-escoffery", title: "With Shaun Escoffery" },
  { id: "boney-m", title: "With Boney M" },
  { id: "finally", title: "Finally" },
  { id: "love-like-this", title: "Love Like This Before" },
  { id: "fay-simpson", title: "With Fay Simpson" },
  { id: "ruby-turner-performing", title: "With Ruby Turner" },
  { id: "wonderful-words", title: "Wonderful Words of Life" },
  { id: "killing-me-softly", title: "Killing Me Softly" },
  { id: "606", title: "606" },
].map((v) => ({ ...v, src: `/media/videos/${v.id}.mp4`, poster: `/media/videos/${v.id}.jpg` }));
